<app-iota-modal i18n-title title="Create agreement" [modalOptions]="modalOptions" (close$)="onCancelClick()">
    <div modal-body [formGroup]="form">
        <div class="grid grid-cols-3 justify-start items-start gap-4">
            <label i18n>Name:</label>
            <input type="text" class="col-span-2 input input-bordered" formControlName="name" />

            <label i18n>Comment:</label>
            <textarea
                class="col-span-2 textarea textarea-bordered"
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="20"
                formControlName="comment"
            ></textarea>

            <div class="form-control">
                <label class="label">
                    <span class="label-text" i18n>VersionFrom</span>
                </label>
                <div class="flex flex-row items-center">
                    <input type="date" class="input input-bordered" formControlName="versionFrom" />
                </div>
            </div>

            <div class="form-control">
                <label class="label">
                    <span class="label-text" i18n>VersionTo</span>
                </label>
                <div class="flex flex-row items-center">
                    <input type="date" class="input input-bordered" formControlName="versionTo" />
                </div>
            </div>

            <button class="btn self-end" (click)="resetVersionTo()" i18n>Reset VersionTo</button>
        </div>
    </div>

    <div modal-footer class="flex grow justify-between">
        <div class="flex-1"></div>
        <button modal-footer class="btn btn-primary" [ngClass]="{ loading: loading$ | ngrxPush }" (click)="onSaveClick()" i18n>Save</button>
    </div>
</app-iota-modal>
